export { default } from "./SimpleTemplate";
